/** Tickets chrome (create button, status cards, tickets table) is only for that filter view. */
export const isTicketsFilterMode = (filterMode: string): boolean => filterMode === 'tickets';

/** Chip label: Tickets while on documents, Documents while on the tickets table. */
export const documentsTicketsToggleKey = (filterMode: string): string =>
    isTicketsFilterMode(filterMode) ? 'documents' : 'tickets';

export const filterTicketsBySearch = <
    T extends {
        id?: string | number;
        text?: string;
        description?: string;
        document_name?: string;
    },
>(
    tickets: T[],
    search: string
): T[] => {
    const query = search.trim().toLowerCase();
    if (!query) {
        return tickets;
    }
    return tickets.filter(
        (ticket) =>
            String(ticket.id ?? '').includes(query) ||
            ticket.text?.toLowerCase().includes(query) ||
            ticket.description?.toLowerCase().includes(query) ||
            ticket.document_name?.toLowerCase().includes(query)
    );
};

export const filterTicketsByStatus = <T extends { status: string }>(
    tickets: T[],
    status: string | null
): T[] => {
    if (!status) {
        return tickets;
    }
    return tickets.filter((ticket) => ticket.status === status);
};
